import { Visibility } from "@material-ui/icons";
import "./widgetSm.css";

const WidgetSm = () => {
  return (
    <div className="widgetSm">
      <span className="widgetSmTitle">New Users</span>
        <ul className="widgetSmList">
          <li className="widgetSmListItem">
            <img
              src="https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0"
              alt=""
              className="widgetSmImg"
            />
            <div className="widgetSmUser">
              <span className="widgetSmUsername">Williams Agbunu</span>
              <span className="widgetSmUserTitle">Backend Engineer</span>
            </div>
            <button className="widgetSmButton">
                <Visibility className="WidgetSmIcon" />
                Display
              </button>
          </li>
          <li className="widgetSmListItem">
            <img
              src="https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0"
              alt=""
              className="widgetSmImg"
            />
            <div className="widgetSmUser">
              <span className="widgetSmUsername">Williams Agbunu</span>
              <span className="widgetSmUserTitle">Backend Engineer</span>
            </div>
            <button className="widgetSmButton">
                <Visibility className="WidgetSmIcon" />
                Display
              </button>
          </li>
          <li className="widgetSmListItem">
            <img
              src="https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0"
              alt=""
              className="widgetSmImg"
            />
            <div className="widgetSmUser">
              <span className="widgetSmUsername">Williams Agbunu</span>
              <span className="widgetSmUserTitle">Backend Engineer</span>
            </div>
            <button className="widgetSmButton">
                <Visibility className="WidgetSmIcon" />
                Display
              </button>
          </li>
          <li className="widgetSmListItem">
            <img
              src="https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0"
              alt=""
              className="widgetSmImg"
            />
            <div className="widgetSmUser">
              <span className="widgetSmUsername">Williams Agbunu</span>
              <span className="widgetSmUserTitle">Backend Engineer</span>
            </div>
            <button className="widgetSmButton">
                <Visibility className="WidgetSmIcon" />
                Display
              </button>
          </li>
          <li className="widgetSmListItem">
            <img
              src="https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0"
              alt=""
              className="widgetSmImg"
            />
            <div className="widgetSmUser">
              <span className="widgetSmUsername">Williams Agbunu</span>
              <span className="widgetSmUserTitle">Backend Engineer</span>
            </div>
            <button className="widgetSmButton">
                <Visibility className="WidgetSmIcon" />
                Display
              </button>
          </li>
        </ul>
      
    </div>
  );
};

export default WidgetSm;
